export const dict = {
  fr: {
    brand_tagline: "Découvrez d'abord. Postulez ensuite.",
    hero_title: "Le marché caché de l'emploi, révélé.",
    hero_sub: "Proxijob renverse la recherche d'emploi : explorez les entreprises locales sur une carte mondiale, laissez notre IA matcher votre diplôme, et postulez spontanément en un clic.",
    cta_explore: "Explorer la carte",
    cta_signup: "Créer un compte",
    cta_login: "Se connecter",
    nav_map: "Carte",
    nav_suggestions: "Suggestions IA",
    nav_internships: "Stages",
    nav_applications: "Mes candidatures",
    nav_favorites: "Favoris",
    nav_profile: "Profil",
    nav_company: "Espace entreprise",
    nav_admin: "Admin",
    logout: "Déconnexion",
    login_title: "Bon retour",
    login_sub: "Connectez-vous pour découvrir les entreprises près de chez vous.",
    register_title: "Rejoindre Proxijob",
    register_sub: "Créez votre compte candidat en 30 secondes.",
    email: "Email",
    password_label: "Mot de passe",
    name: "Nom complet",
    or: "ou",
    continue_google: "Continuer avec Google",
    account_type: "Type de compte",
    candidate: "Candidat",
    company: "Entreprise",
    no_account: "Pas encore de compte ?",
    have_account: "Déjà un compte ?",
    filter_sector: "Secteur",
    filter_country: "Pays",
    suggested_roles: "Postes suggérés",
    profile_label: "Profil",
    landing_pme_title: "Vous êtes un employeur ? PME, commerce, restaurant, grande entreprise ou service public",
    landing_pme_sub: "Récupérez ou créez votre fiche vitrine Proxijob gratuitement en 3 minutes — quel que soit votre secteur : boutique de quartier, restaurant, artisan, cabinet médical, garage, école, mairie, hôpital, grande entreprise privée. Les étudiants et candidats locaux vous trouvent sur la carte, même quand vous ne recrutez pas activement.",
    landing_pme_cta: "Récupérer ma fiche gratuite",
    landing_pme_cta_alt: "Créer une nouvelle fiche",
    analytics_country_label: "Pays",
    claim_hero_title: "Récupérez votre fiche gratuitement",
    claim_hero_sub: "Vous tenez un commerce, un restaurant, un cabinet, une école, une mairie, un hôpital, une grande entreprise ou une PME ? Peu importe le secteur ou la taille : trouvez votre organisation dans notre base mondiale, récupérez la vitrine, et recevez des candidatures spontanées de talents locaux.",
    claim_badge_free: "100% gratuit — tous secteurs",
    claim_badge_ai: "Fiche IA générée",
    claim_badge_map: "Visible sur la carte",
    claim_step_1: "Étape 1",
    claim_step_2: "Vous ne trouvez pas ?",
    claim_search_title: "Cherchez votre entreprise",
    claim_search_hint: "Tapez le nom (Boulangerie Chez Marie, Restaurant Le Petit Prince…). Nous avons pré-indexé 8 700+ entreprises via Google Places.",
    claim_search_placeholder: "Ex : Boulangerie, Garage, Café...",
    claim_no_result: "Aucune entreprise trouvée avec ce nom. Créez plutôt une nouvelle fiche.",
    claim_create_new: "Créer une nouvelle fiche",
    claim_take_over_btn: "Récupérer",
    claim_owned_btn: "Déjà récupérée",
    claim_already_owned: "Fiche vérifiée",
    claim_new_title: "Créer une nouvelle fiche entreprise",
    claim_new_hint: "Votre entreprise n'est pas encore listée ? Créez-la en 3 minutes avec l'aide de l'IA — description, photos, secteur, contact, offres de stage.",
    claim_new_cta: "Créer ma fiche",
    claim_how_title: "Comment ça marche ?",
    claim_how_1: "Recherchez le nom de votre entreprise ci-dessus.",
    claim_how_2: "Cliquez sur « Récupérer » — un e-mail de vérification est envoyé à votre adresse.",
    claim_how_3: "Confirmez en cliquant sur le lien du mail (auto-validé si votre e-mail correspond au domaine du site).",
    claim_how_4: "Modifiez la vitrine, ajoutez photos, offres de stage, coordonnées — les candidats vous trouvent sur la carte.",
    copied: "Copié !",
    dash_pricing_title: "Boost & Sponsor votre fiche",
    dash_pricing_sub: "Apparaissez en premier sur la carte + badge doré + bannière hebdo. Paiement Stripe, dès 9 €.",
    dash_pricing_cta: "Voir les offres",
    dash_analytics_title: "Statistiques marché (ville / secteur)",
    dash_analytics_sub: "Combien d'employés dans votre secteur ? Combien de candidats disponibles ? Combien de PME concurrentes dans votre ville ? Décision data.",
    dash_analytics_cta: "Voir mes statistiques",
    dash_newpage_title: "Créer une nouvelle page web",
    dash_newpage_sub: "Chaque fiche = un vrai mini-site public avec URL partageable (/vitrine/…). Photos, horaires, équipe, offres, avis clients.",
    dash_newpage_cta: "Créer une nouvelle fiche",
    filter_city: "Ville",
    filter_internship: "Accueille des stagiaires",
    filter_radius: "Rayon (km)",
    filter_reset: "Réinitialiser",
    filter_contract: "Type de contrat",
    contract_stage: "Stage",
    contract_emploi: "Emploi",
    contract_saisonnier: "Saisonnier",
    contract_alternance: "Alternance",
    all_contracts: "Tous types",
    all_sectors: "Tous les secteurs",
    all_countries: "Tous les pays",
    all_cities: "Toutes les villes",
    companies_found: "entreprises trouvées",
    match_score: "match",
    apply_spontaneous: "Candidature spontanée",
    add_favorite: "Ajouter aux favoris",
    remove_favorite: "Retirer des favoris",
    website: "Site web",
    contact: "Contact",
    typical_needs: "Besoins types",
    hosts_interns_yes: "Accueille régulièrement des stagiaires",
    apply_title: "Candidature spontanée",
    apply_message: "Votre message",
    apply_position: "Poste souhaité (optionnel)",
    send: "Envoyer",
    cancel: "Annuler",
    application_sent: "Candidature envoyée !",
    suggestions_title: "Suggestions IA basées sur votre profil",
    suggestions_sub: "Notre IA analyse votre diplôme et vos compétences pour vous suggérer les meilleurs secteurs et entreprises.",
    analyze_btn: "Analyser mon profil",
    analyzing: "Analyse en cours...",
    matched_sectors: "Secteurs recommandés",
    recommended_companies: "Entreprises recommandées",
    profile_title: "Mon profil",
    diploma: "Diplôme",
    specialty: "Spécialité",
    skills: "Compétences (séparées par des virgules)",
    save: "Enregistrer",
    upload_cv: "Importer mon CV (PDF)",
    cv_uploaded: "CV importé",
    internships_title: "Entreprises accueillant des stagiaires",
    internships_sub: "Toutes ces entreprises accueillent régulièrement des stagiaires.",
    applications_title: "Mes candidatures",
    no_applications: "Aucune candidature pour le moment. Explorez la carte pour commencer !",
    company_dash_title: "Espace entreprise",
    company_new: "Créer une fiche entreprise",
    my_companies: "Mes fiches entreprises",
    applications_received: "Candidatures reçues",
    admin_title: "Tableau de bord admin",
    stats: "Statistiques",
    pending_moderation: "Fiches en attente de modération",
    verify: "Valider",
    already_verified: "Vérifiée",
    empty_map: "Aucune entreprise ne correspond à vos filtres.",
    footer_note: "Proxijob — Couverture mondiale, déploiement progressif.",
    fill_all: "Merci de remplir tous les champs.",
    login_fail: "Identifiants invalides.",
    register_fail: "Cet email est déjà utilisé.",
    saved: "Enregistré",
    status_pending: "En attente",
    status_seen: "Vue",
    status_accepted: "Acceptée",
    status_rejected: "Refusée",
    diploma_required: "Renseignez votre diplôme dans votre profil pour lancer l'analyse.",
    fill_diploma_in_profile: "Ajoutez votre diplôme dans votre profil.",
    create_company_title: "Ajouter votre entreprise",
    company_name: "Nom de l'entreprise",
    company_desc: "Description",
    address: "Adresse",
    latitude: "Latitude",
    longitude: "Longitude",
    size: "Taille",
    creating: "Création...",
    company_created: "Fiche entreprise créée !",
    ai_cover_letter: "Générer une lettre IA",
    nav_pricing: "Tarifs",
    nav_roadmap: "Roadmap",
    pricing_title: "Solutions pour les entreprises",
    pricing_sub: "Trouver des candidats est gratuit pour les candidats. Les entreprises boostent leur visibilité avec Proxijob.",
    pricing_candidates_free: "Candidats : 100 % gratuit — pas d'abonnement, pas de paiement.",
    per_month: "/ mois",
    once: "paiement unique",
    subscribe: "S'abonner",
    buy_now: "Acheter",
    most_popular: "Le plus populaire",
    company_only: "Réservé aux comptes entreprise",
    choose_company: "Choisissez la fiche entreprise à booster",
    payment_success_title: "Paiement confirmé 🎉",
    payment_success_sub: "Merci ! Votre offre est active.",
    payment_pending: "Paiement en cours de traitement...",
    payment_cancel_title: "Paiement annulé",
    payment_cancel_sub: "Aucun montant n'a été débité. Vous pouvez réessayer quand vous voulez.",
    back_to_dashboard: "Retour au dashboard",
    view_pricing: "Voir les tarifs",
    ai_generating: "Génération IA...",
    ai_letter_ready: "Lettre générée par IA",
    parse_cv_ai: "Analyser mon CV avec l'IA",
    parse_cv_success: "Profil enrichi depuis le CV !",
    vivier_title: "Vivier saisonnier",
    vivier_sub: "Talents archivés pour vos futurs besoins / saisonniers.",
    add_to_vivier: "Ajouter au vivier",
    vitrine_public: "Voir la page vitrine publique",
    hero_seed_note: "Sources : Google Places + OpenCorporates + inscription libre (V1 : données seed)",
    near_me: "Autour de moi",
    locate_me: "Me localiser",
    locate_denied: "Géolocalisation refusée par le navigateur",
    radius: "Rayon",
    km: "km",
    center_set: "Centre défini",
    reset_center: "Réinitialiser le centre",
    gallery: "Galerie",
    team: "Équipe",
    news: "Actualités",
    enrich_page: "Enrichir ma fiche",
    enrich_title: "Enrichir la fiche vitrine",
    enrich_gallery_label: "URLs d'images (une par ligne)",
    enrich_team_name: "Nom",
    enrich_team_role: "Poste",
    enrich_add: "Ajouter",
    enrich_remove: "Supprimer",
    enrich_news_title: "Titre",
    enrich_news_body: "Contenu",
    enrich_news_date: "Date",
    enrich_saved: "Fiche mise à jour !",
    import_places: "Importer via Google Places",
    import_places_sub: "Importer les entreprises réelles autour d'un point géographique.",
    import_lat: "Latitude",
    import_lng: "Longitude",
    import_radius: "Rayon (m)",
    import_run: "Lancer l'import",
    import_success: "entreprises importées",
    import_no_key: "Clé Google Places manquante — configurez GOOGLE_PLACES_API_KEY dans le backend.",
    filter_students: "Jobs étudiants / d'été",
    roadmap_title: "Roadmap Études + Premier Job",
    roadmap_sub: "Explorez un métier : notre IA vous montre le parcours d'études ET les jobs accessibles dès aujourd'hui pour vous former sur le terrain.",
    roadmap_placeholder: "Quel métier vous fait rêver ? (ex : Technicien robotique, Cuisinier, Programmeur)",
    roadmap_level_placeholder: "Votre niveau actuel (optionnel : Terminale, Bac+2...)",
    roadmap_go: "Tracer ma roadmap",
    roadmap_diploma_track: "Parcours d'études",
    roadmap_pathways: "Chemins possibles selon votre situation",
    roadmap_pathways_hint: "Plusieurs voies mènent au même métier. Choisissez celle qui vous ressemble.",
    roadmap_pathway_audience: "Idéal pour",
    roadmap_pathway_duration: "Durée totale",
    roadmap_entry_jobs: "Premiers pas accessibles maintenant",
    roadmap_step: "Étape",
    roadmap_encouragement: "Message d'encouragement",
    roadmap_companies_nearby: "Entreprises locales qui accueillent les jeunes",
    roadmap_certifications: "Certifications recommandées pour booster votre CV",
    roadmap_certifications_hint: "Formations courtes, badges & attestations qui font la différence dans votre région.",
    reviews_title: "Avis des candidats",
    reviews_write_prompt: "Laissez un avis sur cette entreprise",
    reviews_edit_prompt: "Mettez à jour votre avis",
    reviews_placeholder: "Partagez votre expérience (accueil, ambiance, encadrement, missions confiées…)",
    reviews_submit: "Publier",
    reviews_login_prompt: "Connectez-vous pour laisser un avis sur cette entreprise.",
    reviews_empty: "Aucun avis pour le moment. Soyez le premier à partager votre expérience !",
    reviews_count_label: "avis",
    profile_location_title: "Où habitez-vous ?",
    profile_location_hint: "On adapte la carte, la Roadmap IA et vos stages à votre région.",
    home_country: "Pays",
    home_region: "Région / Province",
    home_city: "Ville",
    detect_my_location: "Détecter automatiquement",
    internships_all: "Toutes les régions",
    internships_near_me: "Près de chez moi",
    internships_setup_location: "Renseignez votre localisation dans le profil",
    internships_near_me_cta: "Voir les stages près de chez moi",
    internships_empty: "Aucune entreprise n'accueille de stagiaires dans cette zone pour l'instant.",
    internships_show_all: "Voir toutes les régions",
    young_checkbox: "Je suis étudiant·e / premier emploi (sans expérience)",
    young_hint: "L'IA adaptera le message : motivation, curiosité, projet d'études — pas de CV vide.",
  },
  en: {
    brand_tagline: "Discover first. Apply next.",
    hero_title: "The hidden job market, revealed.",
    hero_sub: "Proxijob flips the job search: explore local companies on a world map, let our AI match your degree, and apply spontaneously in one click.",
    cta_explore: "Explore the map",
    cta_signup: "Create an account",
    cta_login: "Sign in",
    nav_map: "Map",
    nav_suggestions: "AI Suggestions",
    nav_internships: "Internships",
    nav_applications: "My applications",
    nav_favorites: "Favorites",
    nav_profile: "Profile",
    nav_company: "Company hub",
    nav_admin: "Admin",
    logout: "Log out",
    login_title: "Welcome back",
    login_sub: "Sign in to discover companies near you.",
    register_title: "Join Proxijob",
    register_sub: "Create your candidate account in 30 seconds.",
    email: "Email",
    password_label: "Password",
    name: "Full name",
    or: "or",
    continue_google: "Continue with Google",
    account_type: "Account type",
    candidate: "Candidate",
    company: "Company",
    no_account: "No account yet?",
    have_account: "Already have an account?",
    filter_sector: "Sector",
    filter_country: "Country",
    suggested_roles: "Suggested roles",
    profile_label: "Profile",
    landing_pme_title: "Are you an employer? SME, shop, restaurant, large company or public service",
    landing_pme_sub: "Claim or create your free Proxijob showcase page in 3 minutes — whatever your sector: neighborhood shop, restaurant, craftsman, medical clinic, garage, school, city hall, hospital, large private company. Local students and job seekers find you on the map, even when you're not actively hiring.",
    landing_pme_cta: "Claim my free page",
    landing_pme_cta_alt: "Create a new page",
    analytics_country_label: "Country",
    claim_hero_title: "Claim your free company page",
    claim_hero_sub: "Run a shop, restaurant, workshop, salon, clinic or SME? Find your business in our global database, claim the page, and receive spontaneous applications from local talent.",
    claim_badge_free: "100% free",
    claim_badge_ai: "AI-generated page",
    claim_badge_map: "Visible on the map",
    claim_step_1: "Step 1",
    claim_step_2: "Can't find it?",
    claim_search_title: "Find your company",
    claim_search_hint: "Type the name (Marie's Bakery, Le Petit Prince Restaurant…). We pre-indexed 8 700+ businesses via Google Places.",
    claim_search_placeholder: "Ex: Bakery, Garage, Café...",
    claim_no_result: "No business found with this name. Create a new page instead.",
    claim_create_new: "Create a new page",
    claim_take_over_btn: "Claim",
    claim_owned_btn: "Already claimed",
    claim_already_owned: "Verified",
    claim_new_title: "Create a new company page",
    claim_new_hint: "Your business is not listed yet? Create it in 3 minutes with AI help — description, photos, sector, contact, internships.",
    claim_new_cta: "Create my page",
    claim_how_title: "How it works",
    claim_how_1: "Search for your company name above.",
    claim_how_2: "Click 'Claim' — a verification email is sent to your inbox.",
    claim_how_3: "Confirm via the email link (auto-approved if your email matches the website domain).",
    claim_how_4: "Edit the page, add photos, internships and contact info — candidates find you on the map.",
    copied: "Copied!",
    dash_pricing_title: "Boost & Sponsor your page",
    dash_pricing_sub: "Appear first on the map + gold badge + weekly featured banner. Pay with Stripe from €9.",
    dash_analytics_title: "Market stats (by city / sector)",
    dash_analytics_sub: "How many employees in your sector? How many candidates available? How many SMEs competing in your city? Data-driven decisions.",
    dash_analytics_cta: "See my stats",
    dash_pricing_cta: "See plans",
    dash_newpage_title: "Create a new web page",
    dash_newpage_sub: "Each page = a real public mini-site with a shareable URL (/vitrine/…). Photos, hours, team, offers, customer reviews.",
    dash_newpage_cta: "Create a new page",
    filter_city: "City",
    filter_internship: "Hosts interns",
    filter_radius: "Radius (km)",
    filter_reset: "Reset",
    filter_contract: "Contract type",
    contract_stage: "Internship",
    contract_emploi: "Job",
    contract_saisonnier: "Seasonal",
    contract_alternance: "Work-study",
    all_contracts: "All types",
    all_sectors: "All sectors",
    all_countries: "All countries",
    all_cities: "All cities",
    companies_found: "companies found",
    match_score: "match",
    apply_spontaneous: "Spontaneous apply",
    add_favorite: "Add to favorites",
    remove_favorite: "Remove favorite",
    website: "Website",
    contact: "Contact",
    typical_needs: "Typical needs",
    hosts_interns_yes: "Regularly hosts interns",
    apply_title: "Spontaneous application",
    apply_message: "Your message",
    apply_position: "Position (optional)",
    send: "Send",
    cancel: "Cancel",
    application_sent: "Application sent!",
    suggestions_title: "AI suggestions based on your profile",
    suggestions_sub: "Our AI analyzes your degree and skills to suggest the best sectors and companies.",
    analyze_btn: "Analyze my profile",
    analyzing: "Analyzing...",
    matched_sectors: "Recommended sectors",
    recommended_companies: "Recommended companies",
    profile_title: "My profile",
    diploma: "Degree",
    specialty: "Specialty",
    skills: "Skills (comma-separated)",
    save: "Save",
    upload_cv: "Upload my CV (PDF)",
    cv_uploaded: "CV uploaded",
    internships_title: "Companies that host interns",
    internships_sub: "All these companies regularly host interns.",
    applications_title: "My applications",
    no_applications: "No application yet. Explore the map to start!",
    company_dash_title: "Company hub",
    company_new: "Create a company page",
    my_companies: "My company pages",
    applications_received: "Applications received",
    admin_title: "Admin dashboard",
    stats: "Stats",
    pending_moderation: "Pending moderation",
    verify: "Verify",
    already_verified: "Verified",
    empty_map: "No company matches your filters.",
    footer_note: "Proxijob — Global coverage, progressive rollout.",
    fill_all: "Please fill in all fields.",
    login_fail: "Invalid credentials.",
    register_fail: "Email already used.",
    saved: "Saved",
    status_pending: "Pending",
    status_seen: "Seen",
    status_accepted: "Accepted",
    status_rejected: "Rejected",
    diploma_required: "Add your degree in your profile to run analysis.",
    fill_diploma_in_profile: "Add your degree in your profile.",
    create_company_title: "Add your company",
    company_name: "Company name",
    company_desc: "Description",
    address: "Address",
    latitude: "Latitude",
    longitude: "Longitude",
    size: "Size",
    creating: "Creating...",
    company_created: "Company page created!",
    ai_cover_letter: "Generate AI cover letter",
    ai_generating: "AI generating...",
    ai_letter_ready: "AI-generated cover letter",
    nav_pricing: "Pricing",
    nav_roadmap: "Roadmap",
    pricing_title: "Solutions for companies",
    pricing_sub: "Finding candidates is free for candidates. Companies boost their visibility with Proxijob.",
    pricing_candidates_free: "Candidates: 100% free — no subscription, no payment.",
    per_month: "/ month",
    once: "one-time",
    subscribe: "Subscribe",
    buy_now: "Buy now",
    most_popular: "Most popular",
    company_only: "Company accounts only",
    choose_company: "Choose the company page to boost",
    payment_success_title: "Payment confirmed 🎉",
    payment_success_sub: "Thank you! Your offer is active.",
    payment_pending: "Payment being processed...",
    payment_cancel_title: "Payment cancelled",
    payment_cancel_sub: "You have not been charged. You can retry any time.",
    back_to_dashboard: "Back to dashboard",
    view_pricing: "View pricing",
    parse_cv_ai: "Analyze my CV with AI",
    parse_cv_success: "Profile enriched from CV!",
    vivier_title: "Seasonal talent pool",
    vivier_sub: "Talents archived for your future or seasonal needs.",
    add_to_vivier: "Add to talent pool",
    vitrine_public: "View public showcase page",
    hero_seed_note: "Sources: Google Places + OpenCorporates + free registration (V1: seed data)",
    near_me: "Near me",
    locate_me: "Locate me",
    locate_denied: "Geolocation refused by browser",
    radius: "Radius",
    km: "km",
    center_set: "Center set",
    reset_center: "Reset center",
    gallery: "Gallery",
    team: "Team",
    news: "News",
    enrich_page: "Enrich my page",
    enrich_title: "Enrich showcase page",
    enrich_gallery_label: "Image URLs (one per line)",
    enrich_team_name: "Name",
    enrich_team_role: "Role",
    enrich_add: "Add",
    enrich_remove: "Remove",
    enrich_news_title: "Title",
    enrich_news_body: "Content",
    enrich_news_date: "Date",
    enrich_saved: "Page updated!",
    import_places: "Import via Google Places",
    import_places_sub: "Import real companies around a geographic point.",
    import_lat: "Latitude",
    import_lng: "Longitude",
    import_radius: "Radius (m)",
    import_run: "Run import",
    import_success: "companies imported",
    import_no_key: "Google Places API key missing — configure GOOGLE_PLACES_API_KEY in backend.",
    nav_pricing: "Pricing",
    nav_roadmap: "Roadmap",
    pricing_title: "Solutions for companies",
    pricing_sub: "Finding candidates is free for candidates. Companies boost their visibility with Proxijob.",
    pricing_candidates_free: "Candidates: 100% free — no subscription, no payment.",
    per_month: "/ month",
    once: "one-time",
    subscribe: "Subscribe",
    buy_now: "Buy now",
    most_popular: "Most popular",
    company_only: "Company accounts only",
    choose_company: "Choose the company page to boost",
    payment_success_title: "Payment confirmed 🎉",
    payment_success_sub: "Thank you! Your offer is active.",
    payment_pending: "Payment being processed...",
    payment_cancel_title: "Payment cancelled",
    payment_cancel_sub: "You have not been charged. You can retry any time.",
    back_to_dashboard: "Back to dashboard",
    view_pricing: "View pricing",
    filter_students: "Student / summer jobs",
    roadmap_title: "Studies + First Job Roadmap",
    roadmap_sub: "Explore a career: our AI shows the diploma track AND accessible entry-level jobs you can grab today to learn on the field.",
    roadmap_placeholder: "What career do you dream of? (e.g. Robotics Technician, Cook, Programmer)",
    roadmap_level_placeholder: "Your current level (optional: High school, Bac+2...)",
    roadmap_go: "Draw my roadmap",
    roadmap_diploma_track: "Diploma track",
    roadmap_pathways: "Possible pathways for your situation",
    roadmap_pathways_hint: "Several routes lead to the same career. Pick the one that fits you.",
    roadmap_pathway_audience: "Best for",
    roadmap_pathway_duration: "Total duration",
    roadmap_entry_jobs: "First steps accessible now",
    roadmap_step: "Step",
    roadmap_encouragement: "Encouragement",
    roadmap_companies_nearby: "Local companies open to young people",
    roadmap_certifications: "Recommended certifications to boost your CV",
    roadmap_certifications_hint: "Short trainings, badges & credentials that make a difference in your region.",
    reviews_title: "Candidate reviews",
    reviews_write_prompt: "Leave a review about this company",
    reviews_edit_prompt: "Update your review",
    reviews_placeholder: "Share your experience (welcome, atmosphere, mentoring, tasks assigned…)",
    reviews_submit: "Post",
    reviews_login_prompt: "Sign in to leave a review about this company.",
    reviews_empty: "No reviews yet. Be the first to share your experience!",
    reviews_count_label: "reviews",
    profile_location_title: "Where do you live?",
    profile_location_hint: "We tailor the map, AI Roadmap and internships to your region.",
    home_country: "Country",
    home_region: "Region / Province",
    home_city: "City",
    detect_my_location: "Detect automatically",
    internships_all: "All regions",
    internships_near_me: "Near me",
    internships_setup_location: "Set your location in your profile",
    internships_near_me_cta: "See internships near me",
    internships_empty: "No company currently welcomes interns in this area.",
    internships_show_all: "Show all regions",
    young_checkbox: "I'm a student / first job (no experience)",
    young_hint: "AI will adapt the message: motivation, curiosity, study project — no blank CV.",
  }
};

// Extend with ES + DE dictionaries defined in i18n_extra.js
import { dictES, dictDE } from "./i18n_extra";
dict.es = dictES;
dict.de = dictDE;

// Language lookup: exact lang → English fallback → French fallback → raw key.
export const t = (lang, key) => (
  (dict[lang] && dict[lang][key]) ||
  (dict.en && dict.en[key]) ||
  (dict.fr && dict.fr[key]) ||
  key
);

// Inline picker for ad-hoc strings we don't want to add to the full dict.
// Usage: pickLang(lang, { fr: "Ma région", en: "My region", es: "…", de: "…" })
// Falls back to fr → en → first available value.
export const pickLang = (lang, values) => (
  (values && (values[lang] ?? values.fr ?? values.en ?? Object.values(values)[0])) || ""
);
